class Filter{
    constructor(){
        this.status=false;
        this.jobTitle = false;
        this.institude = false;
        this.agencyName = false;
    }

    resetFilter(){
        this.status=false;
        this.jobTitle = false;
        this.institude = false;
        this.agencyName = false;
    }
}

export default Filter;